import Vue from "vue";
import Vuex from "vuex";
import VihBaseConteosFiltros, {
  generateEqualConditions,
  generateRangeConditions,
  generateCvegeoConditions,
} from "@/components/mapa/capas/VihBaseConteosFiltros.js";

Vue.use(Vuex);

const modoInicialMapa = "inicial";

export default new Vuex.Store({
  state: {
    hasMainNav: true,
    openMainNav: false,
    openGobNav: false,
    hasA11yMenu: true,
    openA11yMenu: false,
    vista_simplificada: false,
    enlaces_subrayados: false,
    cambiar_tipografia: false,

    nombre_eni: "Salud",

    version_proyecto: process.env.PACKAGE_VERSION,
    actualizacion_proyecto: process.env.DATE_DEPLOY,
    entorno_proyecto: process.env.ENV_DEPLOY,
    cdn_archivos_dominio: process.env.VUE_APP_CDN_ARCHIVOS,

    fechaActualizacion: "07/02/2023",

    mapa: {
      modo: modoInicialMapa, //estatal, municipal, etc...
      cvesEdo: [], //array de claves de estados seleccionados, si es uno solo el array tendra un elemento
      cvesMun: [], //array de claves de municipios seleccionados, si es solo uno el array tendra un elemento
      capasActivas: [],

      // controles
      sexo: {
        "Mujer cis": { conteo: 0, checked: true },
        "Mujer trans": { conteo: 0, checked: true },
        "Hombre cis": { conteo: 0, checked: true },
        "Hombre trans": { conteo: 0, checked: true },
      },
      edad: {
        0: { conteo: 0, checked: true },
        1: { conteo: 0, checked: true },
        2: { conteo: 0, checked: true },
        3: { conteo: 0, checked: true },
        4: { conteo: 0, checked: true },
      },
      seguridadSocial: {
        //"Sin seguridad": {conteo:0,checked:true},
        IMSS: { conteo: 0, checked: true },
        INSABI: { conteo: 0, checked: true },
        Otro: { conteo: 0, checked: true },
        ISSSTE: { conteo: 0, checked: true },
        INSABI: { conteo: 0, checked: true },
        Desconoce: { conteo: 0, checked: true },
        null: { conteo: 0, checked: true },
      },
      resistencia: {
        Susceptible: { conteo: 0, checked: true },
        NNRTI: { conteo: 0, checked: true },
        NRTI: { conteo: 0, checked: true },
        PI: { conteo: 0, checked: true },
        Compleja: { conteo: 0, checked: true },
        INSTI: { conteo: 0, checked: true },
      },
      linfocitos: {},

      controlesCondiciones: [],
      municipiosConteos: {},
      cpConteos: {},
      conteosPorfecha: {},
      reproductorDiaActual: -1,
      reproductorPlay: false,
      conteosControlesListos: true,
    },
    conteo_linfocitos: {},
    orden_clusters: "numero-nodos",
    check_antirretroviral: [],
    check_carga_viral: [],
    check_conteo_linfocitos: [],
    check_distancia_genetica: [],
    check_pacientes_cluster: [],
    check_genero: ["Hombre cis", "Mujer cis", "Hombre trans", "Mujer trans"],
    check_edad: ["16-24", "25-34", "35-44", "45-54", "55-64", "65 y más", "Sin dato"],
    check_ss: ["No sabe", "IMSS", "INSABI", "ISSSTE", "Otro", "Sin dato"],

    categorias_distancias_geneticas: [],
    numero_clusters: 0,
    numero_nodos_clusters: 0,
    nodos_totales: 0,
    data_clusters_seguro_social: [
      { cantidad: 1, nombre: "n1" },
      { cantidad: 2, nombre: "n3" },
    ],
    data_clusters_sexo: [
      { cantidad: 1, nombre: "n1" },
      { cantidad: 2, nombre: "n3" },
    ],
    data_clusters_edad: [
      { cantidad: 1, nombre: "n1" },
      { cantidad: 2, nombre: "n3" },
    ],
    fecha_cluster_slider: Date,
    modalCluster: {
      abierto: false,
      datos: undefined,
      colores: undefined,
    },
  },
  getters: {
    hasMainNav(state) {
      return state.hasMainNav;
    },
    isOpenMainNav(state) {
      return state.openMainNav;
    },
    isOpenGobNav(state) {
      return state.openGobNav;
    },
    hasA11yMenu(state) {
      return state.hasA11yMenu;
    },
    isOpenA11yMenu(state) {
      return state.openA11yMenu;
    },
    tieneVistaSimplificada(state) {
      return state.vista_simplificada;
    },
    tieneEnlacesSubrayados(state) {
      return state.enlaces_subrayados;
    },
    cambiarTipografia(state) {
      return state.cambiar_tipografia;
    },
    obtenerNombreEni(state) {
      return state.nombre_eni;
    },
    versionProyecto(state) {
      return state.version_proyecto;
    },
    actualizacionProyecto(state) {
      return state.actualizacion_proyecto;
    },
    entornoProyecto(state) {
      return state.entorno_proyecto;
    },
    // Datos general
    obtenerFechaActualizacion(state) {
      return `Última actualización: ${state.fechaActualizacion}`;
    },
    // Cluster
    obtenerOrdenClusters(state) {
      return state.orden_clusters;
    },
    actualModalClusterDatos(state) {
      return state.modalCluster.datos;
    },
    actualModalClusterColores(state) {
      return state.modalCluster.colores;
    },
    actualModalClusterEstatus(state) {
      return state.modalCluster.abierto;
    },

    // Mapa
    inicialModoMapa() {
      return modoInicialMapa;
    },
    actualMapaModo(state) {
      return state.mapa.modo;
    },
    actualMapaCvesEdo(state) {
      return state.mapa.cvesEdo;
    },
    actualMapaCvesMun(state) {
      return state.mapa.cvesMun;
    },
    actualMapaModoYCves(state) {
      return {
        modo: state.mapa.modo,
        cvesEdo: state.mapa.cvesEdo,
        cvesMun: state.mapa.cvesMun,
      };
    },
    actualMapaCapasActivas(state) {
      return state.mapa.capasActivas;
    },
    actualMapaSexo(state) {
      return state.mapa.sexo;
    },
    actualMapEadad(state) {
      return state.mapa.edad;
    },
    actualMapaSeguridadSocial(state) {
      return state.mapa.seguridadSocial;
    },
    actualMapaResistencia(state) {
      return state.mapa.resistencia;
    },
    actualMapaMunicipiosConteos(state) {
      return state.mapa.municipiosConteos;
    },
    actualMapaCpConteos(state) {
      return state.mapa.cpConteos;
    },
  },
  mutations: {
    openMainNav(state) {
      state.openMainNav = true;
    },
    closeMainNav(state) {
      state.openMainNav = false;
    },
    toggleMainNav(state) {
      state.openMainNav = !state.openMainNav;
    },
    openGobNav(state) {
      state.openGobNav = true;
    },
    closeGobNav(state) {
      state.openGobNav = false;
    },
    toggleGobNav(state) {
      state.openGobNav = !state.openGobNav;
    },
    toggleA11yMenu(state) {
      state.openA11yMenu = !state.openA11yMenu;
    },
    alternarVistaSimplificada(state) {
      state.vista_simplificada = !state.vista_simplificada;
    },
    quitarVistaSimplificada(state) {
      state.vista_simplificada = false;
    },
    alternarEnlacesSubrayados(state) {
      state.enlaces_subrayados = !state.enlaces_subrayados;
    },
    quitarEnlacesSubrayados(state) {
      state.enlaces_subrayados = false;
    },
    cambiarOrdenClusters(state, valor) {
      state.orden_clusters = valor;
    },
    cambiarFechaClusterSlider(state, val) {
      state.fecha_cluster_slider = val;
    },

    // Mapa
    reiniciarMapaModo(state) {
      state.mapa.modo = modoInicialMapa;
      state.mapa.cvesEdo = [];
      state.mapa.cvesMun = [];
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesEdo,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaModo(state, valor) {
      state.mapa.modo = valor;
    },
    reiniciarMapaCvesEdo(state) {
      state.mapa.cvesEdo = [];
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesEdo,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    addMapaCvesEdo(state, valor) {
      state.mapa.cvesEdo.push(valor);
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesEdo,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaCvesEdo(state, valor) {
      state.mapa.cvesEdo = valor;
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesEdo,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaCvesEdoYModo(state, valor) {
      state.mapa.modo = "estatal";
      state.mapa.cvesEdo = valor;
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesEdo,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    reiniciarMapaCvesMun(state) {
      state.mapa.cvesMun = [];
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesMun,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    addMapaCvesMun(state, valor) {
      state.mapa.cvesMun.push(valor);
      // actualizar lista de estados
      state.mapa.cvesEdo = state.mapa.cvesMun
        .map((mun) => mun.substr(0, 2))
        .filter((val, i, self) => self.indexOf(val) === i);
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesMun,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaCvesMun(state, valor) {
      state.mapa.cvesMun = valor;
      // actualizar lista de estados
      state.mapa.cvesEdo = state.mapa.cvesMun
        .map((mun) => mun.substr(0, 2))
        .filter((val, i, self) => self.indexOf(val) === i);
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesMun,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaCvesMunYModo(state, valor) {
      state.mapa.modo = "municipal";
      state.mapa.cvesMun = valor;
      // actualizar lista de estados
      state.mapa.cvesEdo = state.mapa.cvesMun
        .map((mun) => mun.substr(0, 2))
        .filter((val, i, self) => self.indexOf(val) === i);
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesMun,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    quitarMapaCvesMun(state, valor) {
      state.mapa.cvesMun = state.mapa.cvesMun.filter((mun) => mun != valor);
      // actualizar lista de estados
      if (state.mapa.cvesMun.length == 0) {
        state.mapa.modo = "estatal";
      } else {
        state.mapa.cvesEdo = state.mapa.cvesMun
          .map((mun) => mun.substr(0, 2))
          .filter((val, i, self) => self.indexOf(val) === i);
      }
      //agregar las condiciones de los estados seleccionados a los controles, para que se actualicen sus barras
      state.mapa.controlesCondiciones = generateCvegeoConditions(
        state.mapa.cvesMun,
        "cvegeomun",
        state.mapa.modo,
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaCapasActivas(state, valor) {
      state.mapa.capasActivas = valor;
    },

    /* ################################## CONTROLES DE FILTROS ############################# */
    cambiarMapaSexo(state, valor) {
      Object.keys(state.mapa.sexo).forEach((key) => {
        state.mapa.sexo[key].conteo = valor[key] | 0;
      });
    },
    cambiarMapaSexoChecks(state, valor) {
      Object.keys(state.mapa.sexo).forEach((key) => {
        state.mapa.sexo[key].checked = valor[key];
      });
      state.mapa.controlesCondiciones = generateEqualConditions(state.mapa.sexo, "sexo", [
        ...state.mapa.controlesCondiciones,
      ]);
    },
    cambiarMapaEdad(state, valor) {
      Object.keys(state.mapa.edad).forEach((key) => {
        state.mapa.edad[key].conteo = valor[key] | 0;
      });
    },
    cambiarMapaEdadChecks(state, valor) {
      Object.keys(state.mapa.edad).forEach((key) => {
        state.mapa.edad[key].checked = valor[key];
      });
      state.mapa.controlesCondiciones = generateRangeConditions(
        state.mapa.edad,
        "edad",
        [[0, 30], [30, 45], [45, 59], [59, "MAX_VALUE"], [null]],
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaSeguridadSocial(state, valor) {
      Object.keys(state.mapa.seguridadSocial).forEach((key) => {
        state.mapa.seguridadSocial[key].conteo = valor[key] | 0;
      });
    },
    cambiarMapaSeguridadSocialChecks(state, valor) {
      Object.keys(state.mapa.seguridadSocial).forEach((key) => {
        state.mapa.seguridadSocial[key].checked = valor[key];
      });
      state.mapa.controlesCondiciones = generateEqualConditions(
        state.mapa.seguridadSocial,
        "seguridad_social",
        [...state.mapa.controlesCondiciones]
      );
    },
    cambiarMapaResistencia(state, valor) {
      Object.keys(state.mapa.resistencia).forEach((key) => {
        state.mapa.resistencia[key].conteo = valor[key] | 0;
      });
    },
    cambiarMapaResistenciaChecks(state, valor) {
      Object.keys(state.mapa.resistencia).forEach((key) => {
        state.mapa.resistencia[key].checked = valor[key];
      });
      state.mapa.controlesCondiciones = generateEqualConditions(
        state.mapa.resistencia,
        "resistencia",
        [...state.mapa.controlesCondiciones]
      );
    },

    cambiarMapaLinfocitos(state, valor) {
      //state.mapa.linfocitos = valor
      state.conteo_linfocitos = valor;
    },
    cambiarMapaMunicipiosConteos(state, valor) {
      state.mapa.municipiosConteos = valor;
    },
    cambiarMapaCpConteos(state, valor) {
      state.mapa.cpConteos = valor;
    },
    cambiarMapaConteosPorfecha(state, valor) {
      state.mapa.conteosPorfecha = valor;
    },
    cambiarConteosControlesListos(state, valor) {
      state.mapa.conteosControlesListos = valor;
    },
    cambiarMapaReproductorDiaActual(state, valor) {
      state.mapa.reproductorDiaActual = valor.value;
      if (valor.refreshConteos) {
        const dia = Object.keys(state.mapa.conteosPorfecha)[valor.value];
        state.mapa.municipiosConteos = state.mapa.conteosPorfecha[dia].cvegeomun;
        state.mapa.cpConteos = state.mapa.conteosPorfecha[dia].cp;
        //controles de sexo
        Object.keys(state.mapa.sexo).forEach((key) => {
          state.mapa.sexo[key].conteo = state.mapa.conteosPorfecha[dia].sexo[key] | 0;
        });
        //controles de edad
        Object.keys(state.mapa.edad).forEach((key) => {
          state.mapa.edad[key].conteo = state.mapa.conteosPorfecha[dia].edad[key] | 0;
        });
        //controles de seguridad social
        Object.keys(state.mapa.seguridadSocial).forEach((key) => {
          state.mapa.seguridadSocial[key].conteo =
            state.mapa.conteosPorfecha[dia].seguridad_social[key] | 0;
        });
        //controles de resistencia
        Object.keys(state.mapa.resistencia).forEach((key) => {
          state.mapa.resistencia[key].conteo = state.mapa.conteosPorfecha[dia].resistencia[key] | 0;
        });
        //conteos de linfocitos
        state.conteo_linfocitos = state.mapa.conteosPorfecha[dia]["linfocitos"];
      }
    },
    cambiarMapaReproductorPlay(state, play) {
      state.mapa.reproductorPlay = play;
    },
    /**################################################ fin de controles de filtros */
    cambiaAntirretroviral(state, valor) {
      state.check_antirretroviral = valor;
    },
    cambiaCheckCargaViral(state, valor) {
      state.check_carga_viral = valor;
    },
    cambiaCheckConteoLinfocitos(state, valor) {
      state.check_conteo_linfocitos = valor;
    },
    cambiaCheckDistanciaGenetica(state, valor) {
      state.check_distancia_genetica = valor;
    },
    cambiaCategoriasDistanciasGeneticas(state, valor) {
      state.categorias_distancias_geneticas = valor;
    },
    cambiaCheckPacientesCluster(state, valor) {
      state.check_pacientes_cluster = valor;
    },
    cambiaCheckGenero(state, v) {
      state.check_genero = v;
    },
    cambiaCheckEdad(state, v) {
      state.check_edad = v;
    },
    cambiaCheckSS(state, v) {
      state.check_ss = v;
    },

    cambiaDataClustersSeguroSocial(state, valor) {
      state.data_clusters_seguro_social = valor;
    },
    cambiaDataClustersSexo(state, valor) {
      state.data_clusters_sexo = valor;
    },
    cambiaDataClustersEdad(state, valor) {
      state.data_clusters_edad = valor;
    },
    cambiaNumeroClusters(state, valor) {
      state.numero_clusters = valor;
    },
    cambiaNumeroNodosClusters(state, valor) {
      state.numero_nodos_clusters = valor;
    },
    cambiaNodosTotales(state, valor) {
      state.nodos_totales = valor;
    },
    cambiarModalDatos(state, valor) {
      state.modalCluster.datos = valor[0];
      state.modalCluster.colores = valor[1];
      state.modalCluster.abierto = true;
    },
    cambiarTipografiaAtkinson(state) {
      state.cambiar_tipografia = !state.cambiar_tipografia;
    },
    quitarCambioDeTipografia(state) {
      state.cambiar_tipografia = false;
    },
  },
  actions: {
    consultarConteosFiltroMapa(context) {
      const vih_conteoFiltros = new VihBaseConteosFiltros(context.state.mapa.controlesCondiciones);

      vih_conteoFiltros.onLoadData(() => {
        //los conteos por fecha
        context.commit("cambiarMapaConteosPorfecha", vih_conteoFiltros.conteos_by_date);
        if (context.state.mapa.reproductorDiaActual === -1) {
          context.commit("cambiarMapaReproductorDiaActual", {
            value: Object.keys(vih_conteoFiltros.conteos_by_date).length - 1,
            refreshConteos: false,
          });
        }

        //const conteos=vih_conteoFiltros.columnas_conteos_grafica
        const dia = Object.keys(vih_conteoFiltros.conteos_by_date)[
          context.state.mapa.reproductorDiaActual
        ];
        const conteos = vih_conteoFiltros.conteos_by_date[dia];
        context.commit("cambiarMapaSexo", conteos["sexo"]);
        context.commit("cambiarMapaSeguridadSocial", conteos["seguridad_social"]);
        context.commit("cambiarMapaResistencia", conteos["resistencia"]);
        context.commit("cambiarMapaEdad", conteos["edad"]);
        context.commit("cambiarMapaMunicipiosConteos", conteos["cvegeomun"]);
        context.commit("cambiarMapaCpConteos", conteos["cp"]);
        context.commit("cambiarMapaLinfocitos", conteos["linfocitos"]);
        context.commit("cambiarConteosControlesListos", true);

        //console.log(vih_conteoFiltros.conteos_by_date)
        //console.log(conteos)
      });
      context.commit("cambiarConteosControlesListos", false);
      //pausar el reproductor si es que esta corriendo
      if (context.state.mapa.reproductorPlay) {
        context.commit("cambiarMapaReproductorPlay", false);
      }

      vih_conteoFiltros.loadData();
    },
  },
  modules: {},
});
